import { AxisSide } from "../ChartSpec";

/** Matches unit badge horizontal/vertical padding (`UNIT_BADGE_PADDING_CLASS`). */
export const UNIT_BADGE_PADDING_PX = 4;
export const UNIT_BADGE_PADDING_CLASS = "p-[4px]";
export const UNIT_BADGE_HORIZONTAL_PADDING_PX = UNIT_BADGE_PADDING_PX * 2;

/**
 * Button `xs` is `text-sm` / `h-7` below `sm`, but gutter + headroom math always assume `text-xs` /
 * the sm-size height. Force those so paint matches `getBadgeFont` / `UNIT_BADGE_HEADROOM_PX`.
 */
export const UNIT_BADGE_TYPE_CLASS = "h-6 text-xs";

/**
 * Painted height of the badge box — `h-6` from `UNIT_BADGE_TYPE_CLASS`, which is a fixed height, so
 * font size and padding do not add to it. Axis headroom must reserve at least this much or the
 * badge overlaps the top tick label.
 */
export const UNIT_BADGE_HEIGHT_PX = 24;

/** Gap between the plot grid edge and the unit badge outer edge. */
export const UNIT_BADGE_GRID_GAP_PX = 8;

/** Matches Layers2Icon `size-3.5` on the unit badge trigger. */
export const UNIT_BADGE_METRIC_PICKER_ICON_CLASS = "size-3.5";
export const UNIT_BADGE_METRIC_PICKER_ICON_PX = 14;
/** Matches Button `xs` `gap-1` between label and metric-picker icon. */
export const UNIT_BADGE_METRIC_PICKER_GAP_PX = 4;
export const UNIT_BADGE_METRIC_PICKER_EXTRA_PX = UNIT_BADGE_METRIC_PICKER_GAP_PX + UNIT_BADGE_METRIC_PICKER_ICON_PX;

const DEFAULT_ROOT_FONT_SIZE_PX = 16;
const BADGE_TEXT_XS_REM = 0.75;

function getRootFontSizePx(): number {
    if (typeof document === "undefined") return DEFAULT_ROOT_FONT_SIZE_PX;
    const parsed = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_ROOT_FONT_SIZE_PX;
}

/**
 * Live font string for unit badge labels — `text-xs` as px against the <html> root font-size.
 * Formula (not a DOM probe) so gutter math can run without mounting a badge; schedule-editor
 * duration labels probe computed style instead — keep both approaches in sync with what they paint.
 */
export function getBadgeFont(): string {
    return `400 ${getRootFontSizePx() * BADGE_TEXT_XS_REM}px Roboto, sans-serif`;
}

/** True when the left-side metric picker is shown for a side's axes. */
export function hasMetricPickerForSide(side: AxisSide, sideAxisCount: number): boolean {
    return side === AxisSide.Left && sideAxisCount > 1;
}
